import { useRef, useContext } from "react";
import {
  Typography,
  Box,
  Grid,
  Stack,
  Button,
  Dialog,
  Divider,
  IconButton,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { BiMinusCircle } from "react-icons/bi";
// import { useMutation } from "@apollo/client";
//Import from project
import "../../../Style/pagestyle.scss";
import LogoSchool from "../../../Assets/logoSystem.png";
// import PaymentInvoice from "./PaymentInvoice";
import { AuthContext } from "../../../Context/AuthContext";

export default function PrintTeachingTime({
  open,
  handleClose,
  editData,
  studentData,
}) {
  // Change Language
  const { t } = useContext(AuthContext);
  // print
  const componentRef = useRef();
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  // console.log("studentData::", editData, studentData);

  const reactToPrintTrigger = () => {
    return (
      <Button
        sx={{
          width: "30%",
          padding: "6px",
          borderRadius: "10px",
          color: "white",
          backgroundColor: "#0f81c2 !important",
        }}
      >
        Print
      </Button>
    );
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">{t("thead_print")}</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        {/* ============================================ code to print =============================================== */}
        <Box className="print-lesson-container" ref={componentRef}>
          <Box>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction={"column"} spacing={1}>
                  <img src={LogoSchool} alt="logo" style={{ width: "100px" }} />
                  <Stack direction="column" spacing={0.5}>
                    <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title-bold">
                        ឈ្មោះសហគ្រាស :
                      </Typography>
                      <Typography className="print-lesson-header-title-bold">
                        សាលាតន្ត្រីខេត្តសៀមរាប
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title">
                        អាសយដ្ឋាន៖
                      </Typography>
                      <Typography className="print-lesson-header-title">
                        ភូមិមណ្ឌល៣ សង្កាត់ស្លក្រាម
                      </Typography>
                    </Stack>
                    <Typography className="print-lesson-header-title">
                      ក្រុងសៀមរាប ខេត្តសៀមរាប
                    </Typography>
                    <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title">
                        Tel :
                      </Typography>
                      <Typography className="print-lesson-header-title">
                        070 712 096
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" sx={{ marginTop: "50px" }}>
                  <Typography className="print-lesson-header-center-title-kh">
                    តារាងកិច្ចតែងការណ៍
                  </Typography>
                  <Typography className="print-lesson-header-center-title">
                    Lesson Table
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>

            <Box sx={{ marginTop: "15px" }}>
              <Typography className="print-lesson-header-title-bold">
                ព័ត៌មានសិស្ស/Student Information
              </Typography>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
              <Grid container>
                <Grid item xs={6}>
                  <Stack
                    direction="column"
                    sx={{ marginTop: "4px" }}
                    spacing={0.5}
                  >
                    <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title-bold">
                        ឈ្មោះជាភាសាខ្មែរ/Full Name :
                      </Typography>
                      <Typography className="print-lesson-header-title">
                        {studentData?.familyName +
                          " " +
                          studentData?.studentName}
                      </Typography>
                    </Stack>
                    {/* <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title-bold">
                        អត្តលេខ/Khmer ID :
                      </Typography>
                      <Typography className="print-lesson-header-title">
                        {studentData?.studentId}
                      </Typography>
                    </Stack> */}
                    <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title-bold">
                        ភេទ/gender :
                      </Typography>
                      <Typography className="print-lesson-header-title">
                        {studentData?.gender === "Male"
                          ? t("thead_male")
                          : t("thead_female")}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack
                    direction="column"
                    sx={{ marginTop: "4px" }}
                    spacing={0.5}
                  >
                    <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title-bold">
                        ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                      </Typography>
                      <Typography className="print-lesson-header-title">
                        {moment(studentData?.dob).format("DD-MMM-YYYY")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography className="print-lesson-header-title-bold">
                        លេខទូរស័ព្ទ/Tel :
                      </Typography>
                      <Typography className="print-lesson-header-title">
                        {studentData?.phoneNumber}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "10px" }}>
              <Typography className="print-lesson-header-title-bold">
                កិច្ចតែងការណ៍/Lesson
              </Typography>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>

            <table className="print-lesson-table">
              <tr>
                <th style={{ width: "5%" }} align="left">
                  <div>ល.រ</div>
                  <div>N⁰</div>
                </th>
                <th style={{ width: "20%" }} align="left">
                  <div>ថ្នាក់</div>
                  <div>Class</div>
                </th>
                <th style={{ width: "15%" }} align="left">
                  <div>មុខវិជ្ជា</div>
                  <div>Subject</div>
                </th>
                <th style={{ width: "15%" }} align="left">
                  <div>ថ្ងៃចាប់ផ្តើម</div>
                  <div>From date</div>
                </th>
                <th style={{ width: "15%" }} align="left">
                  <div>ថ្ងៃបញ្ចប់</div>
                  <div>To date</div>
                </th>
                <th style={{ width: "30%" }} align="left">
                  <div>មេរៀន</div>
                  <div>Lesson</div>
                </th>
                {/* <th style={{ width: "15%" }} align="left">
                  <div>ចំណាំ</div>
                  <div>Note</div>
                </th> */}
              </tr>

              {editData?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td align="left">{index + 1}</td>
                    <td align="left">
                      {row?.classId?.courseId?.khName +
                        " " +
                        row?.classId?.className}
                    </td>
                    <td align="left">{row?.subjectId?.khName}</td>
                    <td align="left">{moment(row?.fromDate).format("DD MMM YYYY")}</td>
                    <td align="left">{moment(row?.toDate).format("DD MMM YYYY")}</td>
                    <td align="left" style={{ whiteSpace: "pre-line" }}>
                      {row?.lesson}
                    </td>
                    {/* <td>{row?.remark}</td> */}
                  </tr>
                );
              })}
            </table>
          </Box>
        </Box>

        <Stack direction="row" justifyContent="right">
          <ReactToPrint
            removeAfterPrint
            content={reactToPrintContent}
            trigger={reactToPrintTrigger}
            documentTitle={`${studentData?.fullName}-lesson`}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
